export const SUPPLIER_ORG_TYPE = 'Supplier'
export const DISTRICT_ORG_TYPE = 'District'
export const IMS_ORG_TYPE = 'IMS'

export type ORG_TYPES = 'Supplier' | 'District' | 'IMS'
